var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "slash-application",
    attrs: {
      "id": "app"
    }
  }, [_c('img', {
    attrs: {
      "src": require('@/assets/images/logo.png'),
      "alt": "App Logo"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }